import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getLabMembers(labId: number, fetch: Fetch) {
    return fetch(
        `/lab-member?lab=${labId}`,
        { method: 'GET' },
        schemas.LabMembersResponse
    );
}

export const useLabMembersQuery = (labId: number | undefined, enabled: boolean) => {
    return useQuery({
        queryKey: ['labMembers', labId],
        enabled: enabled && !!labId,
        retry: false,
        networkMode: 'always',
        queryFn: async () => {
            if (!labId) {
                return { labMembers: [] }
            }
            return getLabMembers(labId, fetch);
        }
    });
};
